"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _ExperimentContext = _interopRequireDefault(require("../context/ExperimentContext"));

var _duck = require("../duck");

var _utils = require("../utils");

var _state = require("../state");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ExperimentProvider = function ExperimentProvider(_ref) {
  var fetchExperiments = _ref.fetchExperiments,
      trackingHandler = _ref.trackingHandler,
      errorHandler = _ref.errorHandler,
      initialState = _ref.initialState,
      children = _ref.children,
      schedulerOptions = _ref.schedulerOptions,
      defaultSegmentationState = _ref.defaultSegmentationState;

  if (trackingHandler) {
    (0, _utils.warnOnce)('trackingHandler is deprecated and unused');
  }

  var _useState = (0, _react.useState)(function () {
    return (0, _state.createStore)({
      reducer: _state.reducer,
      options: schedulerOptions,
      initialValue: defaultSegmentationState
    });
  }),
      _useState2 = _slicedToArray(_useState, 1),
      _useState2$ = _useState2[0],
      segmentationDispatch = _useState2$.dispatch,
      subscribe = _useState2$.subscribe;

  var segmentationState = (0, _react.useRef)(defaultSegmentationState);

  var initialValue = _objectSpread({
    experiments: {},
    experimentCache: {},
    isLoading: true,
    consentProvided: false
  }, initialState);

  var _useReducer = (0, _react.useReducer)(_duck.reducer, initialValue),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var actions = (0, _react.useMemo)(function () {
    return _objectSpread({}, (0, _duck.mapDispatchToActions)(dispatch), {}, (0, _state.mapDispatchToActions)(segmentationDispatch));
  }, [dispatch, segmentationDispatch]);
  (0, _react.useEffect)(function () {
    var unsubscribe = subscribe(
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(value) {
        var experiments, updateExperiments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                segmentationState.current = value;
                _context.next = 3;
                return fetchExperiments(value);

              case 3:
                experiments = _context.sent;
                updateExperiments = actions.updateExperiments;
                updateExperiments(experiments);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    return unsubscribe;
  }, []);

  var selectors = _objectSpread({}, (0, _duck.mapStateToSelectors)(state), {
    getSegmentationState: (0, _react.useCallback)(function () {
      return segmentationState.current;
    }, [segmentationState])
  });

  var value = (0, _react.useMemo)(function () {
    return {
      actions: actions,
      selectors: selectors,
      fetchExperiments: fetchExperiments,
      errorHandler: errorHandler
    };
  }, [actions, selectors, fetchExperiments, errorHandler]);
  return _react.default.createElement(_ExperimentContext.default.Provider, {
    value: value
  }, children);
};

ExperimentProvider.propTypes = {
  fetchExperiments: _propTypes.func.isRequired,
  trackingHandler: _propTypes.func,
  errorHandler: _propTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  initialState: _propTypes.object,
  children: _propTypes.node.isRequired,
  // because we might have multiple schedulers there is no schema for
  // the options as this may change based on scheduler
  // eslint-disable-next-line react/forbid-prop-types
  schedulerOptions: _propTypes.object,
  defaultSegmentationState: (0, _propTypes.shape)({
    experimentData: _propTypes.object
  })
};
ExperimentProvider.defaultProps = {
  initialState: {},
  trackingHandler: null,
  errorHandler: null,
  schedulerOptions: {},
  defaultSegmentationState: {
    experimentData: {}
  }
};
var _default = ExperimentProvider;
exports.default = _default;